module.exports = __webpack_public_path__ + "static/3-a75bde616e8663a831edb497469221ce.png";